'use strict';

const CONTACT_CONSTANTS = {
  ACTIVITY_STATUS: {
    ACTIVE: 'ACTIVE',
    DECEASED: 'DECEASED',
    RETIRED: 'RETIRED',
  },
};

export {
  CONTACT_CONSTANTS,
};
